/* eslint-disable @typescript-eslint/no-use-before-define */
// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="../dist/gui.d.ts" />x


class Scene extends vf.gui.AutoContainer{
    constructor(){
        super();
        this.init();
    }

    private init(){
        let img = this.createDisplayObject("Image", {
            src: "assets/dino.png"
        }, this) as vf.gui.Image;

        let timeline = this.createTimeLine({});
        timeline.to(img, 2000, {
            x: 500
        }, 0)

        let rect = this.createDisplayObject("Rect", {
            width: 100,
            height: 100,
            color: 0xff0000
        }, this);

        let tween = this.createTween(rect);
        tween.to({y: 200}, 2000).start();

        this.setTimeout(5000, ()=>{
            img.x = 0;
            rect.y = 0;
        })
    }
}

export default class TestAutoContainer {

    public constructor(app: vf.Application, uiStage: vf.gui.Stage) {
        this.onLoad(app, uiStage)
    }

    public onLoad(app: vf.Application, uiStage: vf.gui.Stage){
        
        let scene = new Scene();
        uiStage.addChild(scene) 
    }   
}